<template>
  <v-container ma-0 pa-0 fluid fill-height style="overflow:hidden">
    <link href="https://fonts.googleapis.com/css?family=VT323" rel="stylesheet" />
    <v-layout fill-height>
      <v-flex xs12 pa-0 fill-height>
        <div class="screenCover fade" :style="{'opacity':black}">
          <div class="camCaption fade2" :style="{'opacity':captionOpacity}">{{cams[imageNum].name}}</div>
        </div>

        <div
          v-if="cams && cameraOptions.showDetails"
          class="timeText top left"
        >Hobart Web Cameras - {{this.time}} - {{cams[imageNum].name}}</div>

        <div
          id="screenColor"
          class="screenColor"
          :style="{'background-image':'url(\''+cams[imageNum].link+'?'+this.minute+')'}"
        >
          <!-- <div class="timeText top">{{this.time}}</div> -->
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      black: 0,
      captionOpacity: 0,
      imageNum: 0,
      time: null,
      minute:null,
       months:[
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        days : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],

      camsX: [
        //{name:"Tasman Bridge",link:'https://rosebayhigh.education.tas.edu.au/wp-content/uploads/webcampic-med.jpg'},
        {
          name: "Argyle and Davey Street",
          link: "https://www.transport.tas.gov.au/__traffic_updates/CapImg2.jpg"
        },
        {
          name: "Railway Roundabout",
          link: "https://www.transport.tas.gov.au/__traffic_updates/CapImg1.jpg"
        },
        {
          name: "Davey Street & Sandy Bay Road",
          link: "https://www.transport.tas.gov.au/__traffic_updates/CapImg3.jpg"
        },
        {
          name: "Tasman Bridge",
          link: "https://www.transport.tas.gov.au/__traffic_updates/CapImg4.jpg"
        },
        {
          name: "kunanyi / Mount Wellington Platform",
          link: "https://hccapps.hobartcity.com.au/webcams/platform"
        },
        {
          name: "kunanyi / Mount Wellington Summit",
          link: "https://hccapps.hobartcity.com.au/webcams/summit"
        },
        {
          name: "Salamanca",
          link:
            "http://120.29.240.91/axis-cgi/mjpg/video.cgi?resolution=720x576&dummy=1542411927643"
        }
      ]
    };
  },
  mounted() {
    setTimeout(this.nextPic, 5000);
    setInterval(this.tic, 1000);
    this.$store.dispatch("loadCameras");
  },
  computed: {
    cameraOptions() {
      return this.$store.getters.getCameraOptions;
    },

    camDuration() {
      return this.cameraOptions.duration * 1000;
    },
    cams() {
      return this.$store.getters.getCameras;
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    }
  },

  methods: {
    tic() {
      var d = new Date(),
        seconds =
          d.getSeconds().toString().length == 1
            ? "0" + d.getSeconds()
            : d.getSeconds(),
        minutes =
          d.getMinutes().toString().length == 1
            ? "0" + d.getMinutes()
            : d.getMinutes(),
        hours =
          d.getHours().toString().length == 1
            ? "0" + d.getHours()
            : d.getHours(),
        ampm = d.getHours() >= 12 ? "pm" : "am"
       

      this.time =
        this.days[d.getDay()] +
        " " +
        this.months[d.getMonth()] +
        " " +
        d.getDate() +
        " " +
        d.getFullYear() +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
        
    },
    nextMinute(){
      var d = new Date(),
       minutes =
          d.getMinutes().toString().length == 1
            ? "0" + d.getMinutes()
            : d.getMinutes(),
        hours =
          d.getHours().toString().length == 1
            ? "0" + d.getHours()
            : d.getHours()
      this.minute= 
        this.months[d.getMonth()] +
        " " +
        d.getDate() +
        " " +
        d.getFullYear() +
        " " +
        hours +
        ":" +
        minutes
    },
    nextPic() {
      this.nextMinute()
      setTimeout(this.switch, 100);

      this.black = 1;
    },
    fadeCaption() {
      this.captionOpacity = 0;
      setTimeout(this.reveal, 50);
    },
    reveal() {
      this.black = 0;
      this.captionOpacity = 0;
      setTimeout(this.nextPic, this.camDuration);
      if (this.cameraOptions.zoom) {
        document.getElementById("screenColor").classList.add("zoom");
      }
    },
    switch() {
      document.getElementById("screenColor").classList.remove("zoom");
      if (this.imageNum == this.cams.length - 1) {
        this.$store.dispatch("loadCameras");
      }
      this.imageNum = (this.imageNum + 1) % this.cams.length;

      this.captionOpacity = 1;

      setTimeout(this.fadeCaption, 150);
    },
    mouseDown(event) {},
    mouseUp(event) {}
  }
};
</script>

<style >
main {
  height: 100%;
}
</style>
<style scoped>
.timeText {
  position: fixed;
  bottom: 0px;
  right: 0px;
  color: #fff;
  font-size: 30px;
  font-family: "VT323", monospace;
  text-shadow: 0px 0 5px #000000;
  line-height: 30px;
  background-color: #00000077;
  text-align: right;
  padding-right: 30px;
  padding-left: 100px;
  width: auto;
  z-index: 1000;
}
.top {
  top: 0px;
  bottom: auto;
}
.left {
  left: 0px;
  right: auto;
}
.camCaption {
  text-align: center;
  position: relative;
  color: #fff;
  font-size: 40px;
  width: 100%;
  top: 50%;
}
.screenColor {
  background-color: #000;
  height: 100%;
  background-size: contain;
  background-position: center;
}
.screenCover {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #000;
}
.fade {
  opacity: 1;
  transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -webkit-transition: opacity 1s ease-in-out;
}
.fade2 {
  opacity: 1;
  transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -webkit-transition: opacity 1s ease-in-out;
}

.zoom {
  animation-name: pulse_animation;
  animation-duration: 10000ms;
}
@keyframes pulse_animation {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Play/WebCam.vue